import CryptoJS from "crypto-js";


const SECRET_KEY = process.env.REACT_APP_ENCRIPTION_KEY;
export const encryptPassword = (password) => {
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
    const encrypted = CryptoJS.AES.encrypt(password, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    })
    return encrypted.toString()
}
